// src/components/AppNav.jsx
// Horizontal tab nav under the header.
// Tabs: [{ id, label, icon, badge }]
//
// CLAUDE CODE: prepend `import React from "react";` etc, replace
// the `const PPIcons = window.PPIcons; ...` lines with real imports,
// and add `export default X;` at the bottom (replacing `window.X = X`).

import React from "react";

function AppNav({ tabs, activeId, onChange, right }) {
  return (
    <nav className="pp-app-nav" role="tablist">
      {tabs.map(t => (
        <button
          key={t.id}
          role="tab"
          aria-current={activeId === t.id ? "page" : undefined}
          className="pp-nav-btn"
          onClick={() => onChange && onChange(t.id)}
        >
          {t.icon && <span style={{ display: "inline-flex", width: 14 }}>{t.icon}</span>}
          {t.label}
          {t.badge ? <span className="pp-nav-badge">{t.badge}</span> : null}
        </button>
      ))}
      {right && <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>{right}</div>}
    </nav>
  );
}

export default AppNav;
